import React from 'react';
import TimesSolid from './times-solid.svg';

const XIcon = ({styles, className}) => {
    return (
        <img src={TimesSolid} style={styles} className={className} alt="Close Menu X" />
    )
}

export default XIcon;